<template>
  <Catalogs
    title="Статусы объекта"
    create-text="Новый"
    :fetch-data="fetchData"
    :route-create="'LocationStatusAdd'"
    :route-edit="'LocationStatusEdit'"
    :route-view="'LocationStatusView'"
    :route-path="'/location_statuses'"
    :can-edit="canEditLocationStatusCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "LocationStatuses",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getLocationStatuses(data);
    },
    canEditLocationStatusCatalogs() {
      return this.hasPermission([PERM.CATALOG_LOCATION_STATUS_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/LocationStatuses/LocationStatuses.vue